/**
 * @generated SignedSource<<50f29a7a892e1a6d5784faca105a7cbc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiPresetQuery$variables = {
  id: string;
};
export type aiPresetQuery$data = {
  readonly aiPreset: {
    readonly id: string;
    readonly imageUrl: string | null;
    readonly name: string;
    readonly previewUrl: string | null;
  } | null;
};
export type aiPresetQuery = {
  response: aiPresetQuery$data;
  variables: aiPresetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AIPresetDTO",
    "kind": "LinkedField",
    "name": "aiPreset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "previewUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiPresetQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "aiPresetQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "1023e74301448cde9409529385abedd3",
    "id": null,
    "metadata": {},
    "name": "aiPresetQuery",
    "operationKind": "query",
    "text": "query aiPresetQuery(\n  $id: ID!\n) {\n  aiPreset(id: $id) {\n    id\n    name\n    previewUrl\n    imageUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "5aaf06ea4ca56204c6660e192a862362";

export default node;
